import { Layout, Skeleton } from "../../components/ui";
import { useDeleteFee, useGetFeeById } from "../../query/feesQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import FeeProfile from "./FeeProfile";

function FeeDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: fee } = useGetFeeById(id);
  const { mutate: deleteFee } = useDeleteFee();

  const handleDelete = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this fee voucher?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) return;
      deleteFee(id, {
        onSuccess: () => {
          swal("Success", "Fee voucher deleted successfully", "success");
          navigate("/fees");
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete voucher", "error");
        },
      });
    });
  };

  return (
    <Layout className="configuration">
      <div className="boxDetails" style={{ background: "transparent", padding: 0, boxShadow: "none" }}>
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && fee && <FeeProfile fee={fee} onDelete={handleDelete} />}
      </div>
    </Layout>
  );
}

export default FeeDetails;
